import { render, staticRenderFns } from "./byCode.vue?vue&type=template&id=0e70f3b5&scoped=true&"
import script from "./byCode.vue?vue&type=script&lang=ts&"
export * from "./byCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e70f3b5",
  null
  
)

export default component.exports